import React from 'react';

import BreakdownTable from '../shared/BreakdownTable';
import { IMetric } from 'maps/metrics';
import BreakdownTableRow from '../shared/BreakdownTableRow';
import useStreamingBreakdownData from './utils/useStreamingBreakdownData';

export interface IBreakdownData {
  breakdown: string;
  data: any[];
}

export interface IBreakdownTableProps {
  isPending: boolean;
  breakdownData: IBreakdownData[];
  activeMetric: IMetric;
}

const StreamingPerformanceBreakdownTable: React.FC<IBreakdownTableProps> = (
  props
) => {
  const { breakdownData, isPending, activeMetric } = props;

  const breakdowns = useStreamingBreakdownData(
    breakdownData,
    activeMetric.value
  );

  const WrappedRowCoponent: React.FC<any> = (props: any) => (
    <BreakdownTableRow {...props} />
  );

  return (
    <>
      {breakdowns && (
        <BreakdownTable
          withIcon={true}
          headers={['Top DSPs', activeMetric.label]}
          breakdowns={breakdowns}
          isPending={isPending}
          activeMetric={activeMetric}
          RowComponent={WrappedRowCoponent}
        />
      )}
    </>
  );
};

export default StreamingPerformanceBreakdownTable;
